import React from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';
import {
  Box,
  NotificationInfoIcon,
  NotificationSuccessIcon,
  Tooltip
} from 'edenred-ui';

export const MyChoiceLabel = ({
  variant = 'success'
}: {
  variant?: 'info' | 'success';
}) => {
  const { t } = useTranslation();
  const {
    gray25,
    primaryFrontColor,
    fontSemiBold,
    sizeSmall,
    greenFrontColor
  } = useTheme();

  if (variant === 'success') {
    return (
      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        gap={0.5}
        fontSize={sizeSmall}
        color={primaryFrontColor}
        fontWeight={fontSemiBold}
        px={1.5}
        border={`1px solid ${gray25}`}
        borderRadius={1}
        height={25}
      >
        <NotificationSuccessIcon color={greenFrontColor} width={16} />
        {t('components.manage_benefits.my_choice_label')}
      </Box>
    );
  }

  return (
    <Tooltip
      arrow
      placement="top"
      id={`credit-card-tooltip`}
      componentsProps={{
        tooltip: {
          sx: {
            maxWidth: '500px'
          }
        }
      }}
      title={t('components.manage_benefits.my_choice_tooltip')}
    >
      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        gap={0.5}
        fontSize={sizeSmall}
        color={primaryFrontColor}
        fontWeight={fontSemiBold}
        px={1.5}
        border={`1px solid ${gray25}`}
        borderRadius={1}
        height={25}
      >
        <NotificationInfoIcon color={primaryFrontColor} width={16} />
        {t('components.manage_benefits.my_choice_label')}
      </Box>
    </Tooltip>
  );
};
